export default {
  home: "Home",
  catalog: "Catalogue",
  news: "News",
  about: "About",
  contacts: "Contacts",
  writers: "Writers",
  events: "Events",
  deposits: "Deposits",
  account: "Account",
  cabinet: "Personal account",
  admin: "Admin",
  login: "Sign in",
  loginMobile: "Sign in",
  logout: "Sign out",
  openMenu: "Open menu",
  closeMenu: "Close menu",
  mainNav: "Main navigation",
  notifications: "Notifications",
  partnerAilaAlt: "AILA",
  ailaEcosystemAria: "AILA, RSL ecosystem",
  portal: {
    events: "My events",
    deposits: "My deposits",
    createEvent: "Create event",
    moderateEvents: "Event moderation",
    moderateDeposits: "Deposit moderation",
    registrations: "My registrations",
    applyDeposit: "Apply for deposit",
  },
}
